module.exports = __webpack_public_path__ + "img/accessory_item_08.340b7609.svg";